/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import * as stringParser from '../../util/string.util'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';
import moment from 'moment';
import { SPECIFICCOMPETITIONID } from '../../configs/commonConfigs';
let oid = OPERATOR_ID.toLowerCase()
export default class WebEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            market: null,
            teams: [],
            evtMeta: {}
        };
    }
    componentWillUnmount() {
        if(!!this.props.socket){
            this.props.socket.off("market_room")
          }
    }
    componentDidMount() {
        // this.props.socket;
        let eventMarket = !!this.props.event.markets && this.props.event.markets.length > 0 ? this.props.event.markets.filter((mkt, k) => {
            return mkt.marketType === "MATCH_ODDS"
        }) : []

        if (this.props.gameCode === '300') {
            eventMarket = eventMarket.length > 0 ? eventMarket[0] : !!this.props.event.markets ? this.props.event.markets.filter((itm) => itm.marketType === "DAILY")[0] : null
        } else {
            eventMarket = eventMarket.length > 0 ? eventMarket[0] : !!this.props.event.markets ? this.props.event.markets[0] : null
        }
        if (!!eventMarket && !!eventMarket.marketBook) {
            let market = !!this.props.feedBooks[eventMarket.marketId] ? this.props.feedBooks[eventMarket.marketId] : eventMarket.marketBook
            // if (!!eventMarket.metadata.eventMeta) {
            //     market.evtMeta = eventMarket.metadata.eventMeta
            // }
            this.setState({ evtMeta: eventMarket.metadata.eventMeta, market: market, teams: eventMarket.runners })
        }
        let stream = ""
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if(!!accData && Object.keys(accData).length > 0) {
            if (this.props.display !== "none" && this.props.subscribedMarkets.indexOf(eventMarket.marketId) === -1) {
                if (this.props.subscriptions.market_room.indexOf(eventMarket.marketId) === -1) {
                    this.props.subscribe('market_room', eventMarket.marketId)
                    this.props.socket.emit('market_room', eventMarket.marketId)
                    this.props.updateSubscribedMarkets(eventMarket.marketId)
                }
            }
            if (this.props.display !== "none") {
                this.props.socket.on("market_room", data => {
                    if (stream !== data) {
                        stream = data
                        let newBook = stringParser.deSrlz(data)
                        // if (!!eventMarket.metadata.eventMeta) {
                        //     newBook.evtMeta = eventMarket.metadata.eventMeta
                        // }
                        if (eventMarket.marketId === newBook.marketId) {
                            this.props.updateBook(eventMarket.marketId, newBook)
                            let curBook = this.state.market
                            curBook.runners.forEach((rn, i) => {
                                let nrn = newBook.runners[i]
                                rn.back.forEach((bk, j) => {
                                    if (!nrn.back[j]) {
                                        return false
                                    }

                                    if ((this.props.gameCode === '300' && bk.line !== nrn.back[j].line) || (this.props.gameCode !== '300' && bk.price !== nrn.back[j].price)) {
                                        nrn.back[j].has_blink = true
                                    } else {
                                        nrn.back[j].has_blink = false
                                    }
                                })
                                rn.lay.forEach((ly, k) => {
                                    if (!nrn.lay[k]) {
                                        return false
                                    }

                                    if ((this.props.gameCode === '300' && ly.line !== nrn.lay[k].line) || (this.props.gameCode !== '300' && ly.price !== nrn.lay[k].price)) {
                                        nrn.lay[k].has_blink = true
                                    } else {
                                        nrn.lay[k].has_blink = false
                                    }
                                })
                                newBook.runners[i] = nrn
                            });
                            this.setState({ market: newBook, evtMeta: eventMarket.metadata.eventMeta }, () => {
                                setTimeout(() => {
                                    curBook.runners.forEach((rn, i) => {
                                        let nrn = newBook.runners[i]
                                        rn.back.forEach((bk, j) => {
                                            if (!nrn.back[j]) {
                                                return false
                                            }
                                            nrn.back[j].has_blink = false
                                        })
                                        rn.lay.forEach((ly, k) => {
                                            if (!nrn.lay[k]) {
                                                return false
                                            }
                                            nrn.lay[k].has_blink = false
                                        })
                                        newBook.runners[i] = nrn
                                    });
                                    this.setState({ market: newBook, evtMeta: eventMarket.metadata.eventMeta })
                                }, 500)
                            })
                        }
                    }
                });
                setInterval(() => {
                    this.props.socket.on("market_room", data => {
                        if (stream !== data) {
                            stream = data
                            let newBook = stringParser.deSrlz(data)
                            // if (!!eventMarket.metadata.eventMeta) {
                            //     newBook.evtMeta = eventMarket.metadata.eventMeta
                            // }
                            if (eventMarket.marketId === newBook.marketId) {
                                this.props.updateBook(eventMarket.marketId, newBook)
                                let curBook = this.state.market
                                curBook.runners.forEach((rn, i) => {
                                    let nrn = newBook.runners[i]
                                    rn.back.forEach((bk, j) => {
                                        if (!nrn.back[j]) {
                                            return false
                                        }
    
                                        if ((this.props.gameCode === '300' && bk.line !== nrn.back[j].line) || (this.props.gameCode !== '300' && bk.price !== nrn.back[j].price)) {
                                            nrn.back[j].has_blink = true
                                        } else {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    rn.lay.forEach((ly, k) => {
                                        if (!nrn.lay[k]) {
                                            return false
                                        }
    
                                        if ((this.props.gameCode === '300' && ly.line !== nrn.lay[k].line) || (this.props.gameCode !== '300' && ly.price !== nrn.lay[k].price)) {
                                            nrn.lay[k].has_blink = true
                                        } else {
                                            nrn.lay[k].has_blink = false
                                        }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                this.setState({ market: newBook, evtMeta: eventMarket.metadata.eventMeta }, () => {
                                    setTimeout(() => {
                                        curBook.runners.forEach((rn, i) => {
                                            let nrn = newBook.runners[i]
                                            rn.back.forEach((bk, j) => {
                                                if (!nrn.back[j]) {
                                                    return false
                                                }
                                                nrn.back[j].has_blink = false
                                            })
                                            rn.lay.forEach((ly, k) => {
                                                if (!nrn.lay[k]) {
                                                    return false
                                                }
                                                nrn.lay[k].has_blink = false
                                            })
                                            newBook.runners[i] = nrn
                                        });
                                        this.setState({ market: newBook, evtMeta: eventMarket.metadata.eventMeta })
                                    }, 500)
                                })
                            }
                        }
                    });
                }, 3000)
                this.props.socket.on('disconnect', () => {
                    if (this.props.display !== "none" && this.props.subscribedMarkets.indexOf(eventMarket.marketId) === -1) {
                        this.props.socket.emit('market_room', eventMarket.marketId)
                    }
                })
            }
        }
    }
    formatDate(date) {
        date = new Date(date)
        let month = [];
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sept";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        let mn = month[date.getMonth()];
        let dt = date.getDate();
        dt = dt > 9 ? dt : "0" + dt
        let hr = date.getHours();
        hr = hr > 9 ? hr : "0" + hr
        let min = date.getMinutes();
        min = min > 9 ? min : "0" + min
        let formatedDate = dt + " " + mn + " " + hr + ":" + min
        return formatedDate
    }
    render() {
        let event = this.props.event
        let is_active = !!this.state.market && this.state.market.status === "OPEN"
        let binmkt = this.props.gameCode === '300' ? event.markets.filter((itm) => itm.marketType === "DAILY")[0] : null
        let accData = JSON.parse(localStorage.getItem("accountData"));
        let liveEventList = JSON.parse(localStorage.getItem("inplayEvents")) ||[];
        let winnereventdic = localStorage.getItem("winnereventdic");
        if(!!winnereventdic){
            winnereventdic = JSON.parse(winnereventdic);
        }
        return (
            <tr style={{ display: this.props.display === "none" ? "none" : "table-row" }}>
                <td className="eventInfo">
                    <div onClick={() => { this.props.history.push(!!winnereventdic && !!winnereventdic["eventDicByID"] && winnereventdic["eventDicByID"][this.props.event.id] ? winnereventdic["eventDicByID"][this.props.event.id] : ("/event/" + this.props.gameCode + "/" + this.props.event.id)); }} className="event-title">
                        <span className="dtime">{this.formatDate(this.props.event.openDate) + " |"}</span>
                        {(liveEventList.indexOf(this.props.event.id) > -1) && <span className="lvnow"></span>}{this.props.gameCode === '300' ? (!!binmkt && binmkt.displayMarketNameTime && binmkt.displayMarketNameTime.length > 0 ? binmkt.displayMarketNameTime[0] : event["name"]) : event["name"]} {!!binmkt && binmkt.displayMarketNameTime && binmkt.displayMarketNameTime.length > 0 && <span>[Time: <b>{binmkt.displayMarketNameTime[1]}</b>]</span>}
                        {/* {this.props.isInplay && <span className="livenow ml-2">Live Now111</span>} */}
                    </div>
                    {(liveEventList.indexOf(this.props.event.id) > -1) && <div className="livenow ml-2 livenownew">Live Now</div>}
                    <div className="d-inline float-right">
                        {!!SPECIFICCOMPETITIONID && this.props.event.competitionId === SPECIFICCOMPETITIONID &&
                            <span className="l-tv">
                                <img className='h-22px' alt="virtual" src={BASE_IMAGE_PATH + "/uimg/game-icon.svg"} />
                            </span>
                        }
                        {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasTv && this.state.evtMeta.hasTv === 'true' && <span className="l-tv">
                            <img alt="TV" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/tv.svg"} />
                        </span>}
                        {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasSpecial && this.state.evtMeta.hasSpecial === 'true' && <span className="p-fancy"></span>}
                        {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasBookMaker && this.state.evtMeta.hasBookMaker === 'true' && <span className="bm1"><img alt="BM" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/bm-icon1.svg"} /></span>}
                        {!!this.state.market && !!this.state.evtMeta && !!this.state.evtMeta.hasSession && this.state.evtMeta.hasSession === 'true' && <span className="fancy1 mr-1"><img alt="Fancy" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/fancy-icon1.svg"} /></span>}
                    </div>

                </td>
                {
                    this.props.gameCode === '300' ?
                        <>
                            <td className="col-home">

                            </td>
                            {/* <td className="col-draw">

                            </td> */}
                            <td className="col-visit" colSpan={2}>
                                <div className={!!this.state.market && this.state.market.status === "OPEN" ? "" : "suspended-full"}>
                                    <a id="btnLay0" className="btn-lay" side="Lay" style={!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[0].lay[0] && this.state.market.runners[0].lay[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[0].lay[0] && is_active ? this.state.market.runners[0].lay[0].line : ""}</div></a>
                                    <a id="btnBack0" className="btn-back" side="Back" style={!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[0].back[0] && this.state.market.runners[0].back[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[0].back[0] && is_active ? this.state.market.runners[0].back[0].line : ""}</div></a>
                                </div>
                            </td>
                        </>
                        :
                        <>
                            <td className="col-home">
                                <div className={!!this.state.market && this.state.market.status === "OPEN" ? "" : "suspended-full"}>
                                    <a id="btnBack0" className="btn-back" side="Back" style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 0 && !!this.state.market.runners[0]?.back[0] && this.state.market.runners[0]?.back[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 0 && !!this.state.market.runners[0]?.back[0] && is_active ? this.state.market.runners[0]?.back[0].price : ""}</div></a>
                                    <a id="btnLay0" className="btn-lay" side="Lay" style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 0 && !!this.state.market.runners[0]?.lay[0] && this.state.market.runners[0]?.lay[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 0 && !!this.state.market.runners[0]?.lay[0] && is_active ? this.state.market.runners[0]?.lay[0].price : ""}</div></a>
                                </div>
                            </td>
                            <td className="col-draw">
                                <div className={!!this.state.market && this.state.market.status === "OPEN" ? "" : "suspended-full"}>
                                    <a id="btnBack2" className="btn-back" side="Back" style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 1 && !!this.state.market.runners[2] && !!this.state.market.runners[2]?.back[0] && this.state.market.runners[2]?.back[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 1 && !!this.state.market.runners[2] && !!this.state.market.runners[2]?.back[0] && is_active ? this.state.market.runners[2]?.back[0].price : ""}</div></a>
                                    <a id="btnLay2" className="btn-lay" side="Lay" style={!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 1 && !!this.state.market.runners[2] && !!this.state.market.runners[2]?.lay[0] && this.state.market.runners[2]?.lay[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners.length > 1 && !!this.state.market.runners[2] && !!this.state.market.runners[2]?.lay[0] && is_active ? this.state.market.runners[2]?.lay[0].price : ""}</div></a>
                                </div>
                            </td>
                            <td className="col-visit">
                                <div className={!!this.state.market && this.state.market.status === "OPEN" ? "" : "suspended-full"}>
                                    <a id="btnBack1" className="btn-back" side="Back" style={!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[1]?.back[0] && this.state.market.runners[1]?.back[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[1]?.back[0] && is_active ? this.state.market.runners[1]?.back[0].price : ""}</div></a>
                                    <a id="btnLay1" className="btn-lay" side="Lay" style={!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[1]?.lay[0] && this.state.market.runners[1]?.lay[0].has_blink ? { background: "gold" } : null}><div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners.length > 0 && this.state.market.runners[1]?.lay[0] && is_active ? this.state.market.runners[1]?.lay[0].price : ""}</div></a>
                                </div>
                            </td>
                        </>
                }

                <td className="col-info">
                    {(!!accData && Object.keys(accData).length > 0) && this.state.market && <a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(this.state.market.marketId); }} className={this.props.pinnedEvents.indexOf(this.state.market.marketId) > -1 ? "add-pin-d select-pin-d" : "add-pin-d"} style={{ "cursor": "pointer" }} title="Add to Multi Markets"></a>}
                </td>
            </tr>
        )
    }
}
